import React from 'react';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { JoyLogoLoader } from '@shared/components/JoyLogoLoader';

/**
 * Lazy because `Envelopes` mounts `RestrictedInternationalShippingWarningProvider`, whose dialog
 * reaches `@apps/admin/postOffice` for a route path — importing it eagerly would pull that whole
 * subtree into the card dashboard chunk. It is also a flag-gated entry point almost nobody loads.
 */
export const LazyEnvelopes = loadable(() => import(/* webpackChunkName: "content/card/envelopes" */ './Envelopes'), 'Envelopes', {
  fallback: <JoyLogoLoader loaderKey="card-envelopes" />,
});
